<template>
	<div class="gallery-side-by-side container ">
		<div v-for="(item, index) in items" :key="index">
			<Cover :item="item" :type="type" />
			<Caption v-if="$path(item, 'caption')" :item="item" />
		</div>
	</div>
</template>

<script>
import Caption from '../Caption.vue'
import Cover from '../Cover.vue'

export default {
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		type: {
			type: String,
			default: '',
		},
	},

	computed: {},
	components: {
		Caption,
		Cover,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.gallery-side-by-side {
	width: 100%;
	display: grid;
	grid-gap: 2rem 4rem;
	grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));

	@include respond-below('phone') {
		grid-template-columns: 1fr;
	}
}
</style>
